import { useCallback } from 'react';

import { useForm } from 'react-final-form';

import type { FormValues } from '#src/app/pages/petitionDetails/shared/types';

export function useSignFormFieldMutator<FIELD extends keyof FormValues>(
	field: FIELD,
): (value: FormValues[FIELD]) => void {
	const form = useForm();

	return useCallback(
		(value) => {
			const { setValue } = form.mutators;
			if (!setValue) throw new Error('The setValue form mutator is not registered');
			setValue(field, value);
		},
		[form, field],
	);
}
